import { render, staticRenderFns } from "./PhieuThuCoGam.vue?vue&type=template&id=566d5de5&scoped=true&"
import script from "./PhieuThuCoGam.vue?vue&type=script&lang=js&"
export * from "./PhieuThuCoGam.vue?vue&type=script&lang=js&"
import style0 from "./PhieuThuCoGam.vue?vue&type=style&index=0&id=566d5de5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566d5de5",
  null
  
)

export default component.exports